import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Alert from "../HtmlElements/Alert";
import * as FeatherIcon from "react-feather";

const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  toggleShowPassword,
  loading,
  handleSubmit,
  showRecaptcha,
  recaptchaRef,
  handleCaptchaChange,
  handleCaptchaExpired,
  handleCaptchaError,
  successMessage,
  error,
  // ++++++++++++++++++++++++++++++++
  showForgotPassword,
  setShowForgotPassword,
  forgotEmail,
  setForgotEmail,
  handleForgotPasswordSubmit,
}) => {
  return (
    <div className="login_right_block">
      <div className="login_block">
        <div className="login_top_icon d-none">
          <img
            src="/img/login/flag.png"
            alt="logo"
            width="50"
            className="login_icon"
          />
        </div>
        <h5 className="login_head">
          {showForgotPassword ? "Forgot Password" : "Login"}
        </h5>
        <p className="login_para">
          Please enter your email {showForgotPassword ? "" : "and password"}
        </p>
        <div className="main_form_login">
          {successMessage && <Alert type="success" message={successMessage} />}
          {error && <Alert type="danger" message={error} />}
          {/* <form onSubmit={handleSubmit}> */}
          <form
            onSubmit={
              showForgotPassword ? handleForgotPasswordSubmit : handleSubmit
            }
          >
            {/* <div className="mb-3">
              <label htmlFor="email" className="form-label custom_label">
                Email
              </label>
              <span className="block input-icon input-icon-right ">
                <input
                  type="email"
                  className="form-control custom_form_control"
                  id="email"
                  placeholder="Please enter your Email Address"
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </span>
            </div> */}
            {!showForgotPassword && (
              <div className="mb-3">
                <label htmlFor="email" className="form-label custom_label">
                  Email
                </label>
                <span className="block input-icon input-icon-right ">
                  <input
                    type="email"
                    className="form-control custom_form_control"
                    id="email"
                    placeholder="Please enter your email address"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                </span>
              </div>
            )}

            {/* <div className="mb-3">
              <label htmlFor="password" className="form-label custom_label">
                Password
              </label>
              <span className="block input-icon input-icon-right position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control custom_form_control"
                  id="password"
                  placeholder="Please enter your Password"
                  autoComplete="off"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
                <div
                  className="input-group-append"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "7px",
                    zIndex: "5",
                  }}
                >
                  <span
                    className=""
                    onClick={toggleShowPassword}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={`fa fa-eye${showPassword ? "" : "-slash"}`}
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              </span>
            </div> */}

            {!showForgotPassword && (
              <div className="mb-3">
                <label htmlFor="password" className="form-label custom_label">
                  Password
                </label>
                <span className="block input-icon input-icon-right position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control custom_form_control"
                    id="password"
                    placeholder="Please enter your password"
                    autoComplete="off"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                  />
                  <div
                    className="input-group-append"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "7px",
                      zIndex: "5",
                    }}
                  >
                    <span
                      onClick={toggleShowPassword}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={`fa fa-eye${showPassword ? "" : "-slash"}`}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </span>
              </div>
            )}

            {showRecaptcha && (
              <div className="mb-3">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaChange}
                  onExpired={handleCaptchaExpired}
                  onErrored={handleCaptchaError}
                />
              </div>
            )}

            <div className="space-6"></div>

            {showForgotPassword && (
              <div className="mb-3">
                <label className="form-label custom_label">
                  Enter your registered email
                </label>
                <input
                  type="email"
                  className="form-control custom_form_control"
                  placeholder="Please enter your email address"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  disabled={loading}
                />
              </div>
            )}

            <button
              disabled={loading}
              type="submit"
              className="btn btn-primary custom_log_btn w-100"
            >
              {/* {loading ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-key"></i>
              )}{" "}
              Sign In to GrowthIQ */}
              {loading ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : showForgotPassword ? (
                <i className="fa fa-envelope"></i>
              ) : (
                <i className="fa fa-key"></i>
              )}{" "}
              {showForgotPassword
                ? "Send Password Reset Request"
                : "Sign In to GrowthIQ"}
            </button>
            {!showForgotPassword && (
              <div className="forgot_block">
                <div className="remember_me invisible">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="rememberCheck"
                    />
                    <label class="form-check-label" for="rememberCheck">
                      Remember me
                    </label>
                  </div>
                </div>
                <div className="forgot_subblock">
                  {/* <a href="#" className="remember_me_link">
                  Forgot Password?
                </a> */}
                  <a
                    href="#"
                    className="remember_me_link"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowForgotPassword(true);
                    }}
                  >
                    Forgot Password?
                  </a>
                </div>
              </div>
            )}

            {showForgotPassword && (
              <div className="back_login">
                <a
                  href="#"
                  className="remember_me_link"
                  onClick={() => {
                    setShowForgotPassword(false);
                    setForgotEmail("");
                    setPassword("");
                  }}
                >
                  <FeatherIcon.ArrowLeft className="comp_icon" />
                  Back to Login
                </a>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
